import CommonService from './common';
import { WEB_SSO } from '../../../utils/urls';

export default class QrCodeService extends CommonService {
  /**
   * [get qrcode url]
   * @param {string} service redirect url after login success
   */
  public getQrcode = (params: {
    service: string;
    extra_params?: object;
  }): Promise<any> => {
    let { service, extra_params = {} } = params;
    return this.request({
      // WARNING: axios can encodeURL
      url: `${WEB_SSO.GET_QRCODE}?service=${encodeURIComponent(service)}`,
      method: 'GET',
      data: extra_params,
    });
  };

  /**
   * [query qrCode status]
   * @param {string} service redirect url after login success
   * @param {string} token result of GetQrcode
   */
  public checkQrconnect = (params: {
    service: string;
    token: string;
    extra_params?: object;
  }): Promise<any> => {
    let { service, token, extra_params = {} } = params;
    return this.request({
      // WARNING: axios can encodeURL
      url: `${WEB_SSO.CHECK_QRCONNECT}?service=${encodeURIComponent(service)}`,
      method: 'GET',
      data: {
        // service,
        token,
        ...extra_params,
      },
    });
  };
}
